export { default } from './category-page-title';
